import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-header',
  standalone: true,
  templateUrl: './header.html',
  styleUrls: ['./header.scss']
})
export class HeaderComponent {
  @ViewChild('building', { static: false }) building!: ElementRef<HTMLImageElement>;

  onMouseMove(event: MouseEvent) {
    if (!this.building) return;

    const { innerWidth, innerHeight } = window;
    const moveX = (event.clientX - innerWidth / 2) / 40; // ajuste de intensidade
    const moveY = (event.clientY - innerHeight / 2) / 40;

    this.building.nativeElement.style.transform = `translate(${moveX}px, ${moveY}px)`;
  }
}
